import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "dropdown-content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "image" }
const _hoisted_7 = { class: "name" }

import {readonly, ref, toRef, watch} from 'vue';
	import emitter from '../main';

	import ImageComponent from '../components/ImageComponent.vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'DriverDropdown',
  props: {
    drivers: {},
    picked: {},
    position: {},
    current: {},
    disabled: { type: Boolean },
    right: { type: Boolean }
  },
  emits: [
		'driverClicked'
	],
  setup(__props: any, { emit: __emit }) {

	const props = __props;

	const emit = __emit;

	emitter.on('showDropdown', (value: number) => onShowDropdown(value));

	const position = readonly([
		"Eerste",
		"Tweede",
		"Derde"
	]);

	const emptyDriver = {
		name: 'null',
		team: {name: ''},
		image: ''
	};
	const displayedDriver = ref({});
	const currentDriver = ref(0);
	const pickedDrivers = toRef(props, 'picked');
	const showDropdown = ref(false);

	watch(() => props.current, (newValue) => {
		if(newValue == undefined)
			currentDriver.value = 0;
		else {
			currentDriver.value = pickedDrivers.value[props.position];
			const driver = props.drivers.filter(x => x.id == currentDriver.value);
			if(driver.length == 0)
				displayedDriver.value = emptyDriver;
			else
				displayedDriver.value = driver[0];
		}
	});

	function updateDriver(position: number, driverId: number) {
		currentDriver.value = driverId;
		emit('driverClicked', position, driverId);
		showDropdown.value = false;
	}

	function clickDropdown() {
		if(!props.disabled)
			showDropdown.value = !showDropdown.value;

		if(showDropdown.value)
			emitter.emit("showDropdown", props.position);
	}

	function onShowDropdown(position: number) {
		if(position != props.position)
			showDropdown.value = false;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown", {'open': showDropdown.value}])
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass({right: props.right})
    }, _toDisplayString(props.position + 1), 3),
    _createElementVNode("button", {
      class: "driver",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (clickDropdown()))
    }, [
      (currentDriver.value == 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(position)[props.position]), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(ImageComponent, {
                src: displayedDriver.value.image
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(displayedDriver.value.name), 1),
              _createElementVNode("p", null, _toDisplayString(displayedDriver.value.team.name), 1)
            ])
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.drivers, (driver) => {
        return (_openBlock(), _createElementBlock("button", {
          key: driver,
          onClick: ($event: any) => (updateDriver(props.position, driver.id)),
          class: _normalizeClass({current: driver.id == currentDriver.value, picked: pickedDrivers.value.filter(x => x == driver.id).length > 0})
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(ImageComponent, {
              src: driver.image
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(driver.name), 1),
            _createElementVNode("p", null, _toDisplayString(driver.team.name), 1)
          ])
        ], 10, _hoisted_5))
      }), 128))
    ])
  ], 2))
}
}

})